import ProjectGroup from '../project-group';

/**
 * Create the action
 */

const { thunk, request, success, error } = ProjectGroup.destroy(({ id, ...data }, fetch) => {

    if (data.transfer_to_id) {
        // Prepare request
        let formData = new FormData();
        formData.append('_method', 'POST');
        ['project_id', 'transfer_to_id']
            .map(key => data[key] !== undefined ? formData.append(key, data[key]) : null);
        
        return fetch.post(`/transfer-project`, formData);

    } else {
        return fetch.delete(`/project-groups/${id}`);
    }
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };